import React, { useContext, useEffect, useState } from 'react'
import { Chart } from 'primereact/chart';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Button } from 'primereact/button';

import Loader from '../../../Base/Components/Loader/Loader';
import Card from '../../../Base/Components/Card/Card';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import { decimalTemplate, formatNumber } from '../../../Base/Services/TemplatesServices';

import { ResumenVentasAnuales } from '../../../API/Ventas/ResumenVentasRequest';
import { colorCotton, colorSintetico, datalabelsLineGerencia, getTitle } from '../../../utils/KPIs/productionUtils';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';
import { setHeightAgGrid } from '../../../Base/Components/Tables/AgGrid/AgGridUtils';
import { getLabel } from '../../../Base/Services/Language/LanguageService';
import { baseLang } from '../../../Base/Lang/BaseLang';
import { Dialog } from 'primereact/dialog';
import ResumenVentasTotales from './ResumenVentasTotales';

const ResumenVentasAnual = ({ date, kpiGerencia, getDatos, setShowModal, altura }) => {

  const { config } = useContext(ConfigContext);

  const [loading, setLoading] = useState(false);
  const [dateSelected, setDateSelected] = useState(new Date());
  const [fechaActual, setFechaActual] = useState(new Date());
  // const [total]
  const [chart, setChart] = useState({
    data: {},
    options: {}
  });
  const [showModalMensuales, setShowModalMensuales] = useState(false);
  let Mes = dateSelected.toLocaleString('es-ES', { month: 'long' })
  const monthName = Mes.charAt(0).toUpperCase() + Mes.slice(1);

  const colorTitle = getTitle(config);

  const fortmatFecha = (mes, value, number, percent) => {
    if (fechaActual.getMonth() + 1 === mes) {
      return <div style={{ textAlign: number || percent ? 'right' : 'left' }} >
        <span className='fw-bold fs-6'>{number? '$ ' : ''} {number ? decimalTemplate(value) : value}</span>
      </div>
    }
    else {
      return <div style={{ textAlign: number || percent ? 'right' : 'left' }}>{number? '$ ' : ''} {number ? decimalTemplate(value) : value}</div>
    }
  }

  const rowClassRules = {
    'ag-rowsBackground-gray': (params) => {
      return (fechaActual.getMonth() + 1) ===  params?.data?.Mes || params?.data?.Mes === 0;
    },
    'ag-rows-bold': (params) => {
      return (fechaActual.getMonth() + 1) === params?.data?.Mes || !params?.data?.Mes;
    }
  };

  const [table, setTable] = useState({
    Data: [],
    rowClassRules: rowClassRules,
    Columns: [
      {
        // Mes
        field: 'Mes',
        header: '#',
        className: 'XXsmall',
        align: 'right',
      },
      {
        // Mes
        field: 'NombreMes',
        header: 'Mes',
        headerEn: 'Month',
        className: 'small',
        // flex: 1,
      },
      {
        // Año
        field: 'Anio',
        header: 'Año',
        headerEn: 'Year',
        className: 'Xsmall',
        align: 'center',
      },
      {
          field: '',
          header: '',
          headerEn: '',
          className: '',
          flex: 1,
      },
      
      {
         headerName: 'Budget',
         children: [
          {
              field: 'KgsPresupuesto',
              header: 'Kgs',
              headerEn: '',
              className: 'small',
              Format: 'Currency',
              Sumary: 'sum',
          },
          
           {
             field: 'PresupuestoAmount',
             header: 'Amount $',
             className: 'medium',
             Format: 'Currency',
             Sumary: 'sum',
             prefix: '$ ',
           },
         ]
      },
      {
         headerName: 'Real',
         children: [
          {
              field: 'KgsVentas',
              header: 'Kgs',
              headerEn: '',
              className: 'small',
              Format: 'Currency',
              Sumary: 'sum',
          },
          
           {
             field: 'VentasAmount',
             header: 'Amount $',
             className: 'medium',
             Format: 'Currency',
             Sumary: 'sum',
             prefix: '$ ',
           },
         ]
      },
      {
        field: 'PercentD',
        header: '(%)',
        type: 'rightAligned',
        Format: 'Porcentaje',
        className: 'Xsmall',
        align: 'center',
        calcFunction: (params) => {
            return (params?.data?.VentasAmount / params?.data?.PresupuestoAmount) * 100
        }

      },
    ],
    scrollHeight: '110%',
    key: 'Mes',
    filter: false,
    hideFilter: true,
  })

  const getInfo = async () => {
    setLoading(true);
    const tempoAnual = await ResumenVentasAnuales(date.getFullYear());
    const data = [...tempoAnual]
    console.log({ data });
    setTable({
      ...table,
      Data: data
    })
    let anualValor = [];
    let anualAmountT = [];
    tempoAnual.forEach((item) => {
      anualValor.push(item.PresupuestoAmount);
      anualAmountT.push(item.VentasAmount);
    });



    const config2 = {
      type: 'bar'
    }

    const months = {
      "Enero": 0, "Febrero": 1, "Marzo": 2, "Abril": 3, "Mayo": 4, "Junio": 5,
      "Julio": 6, "Agosto": 7, "Septiembre": 8, "Octubre": 9, "Noviembre": 10, "Diciembre": 11
    };

    setChart({
      data: {
        labels: Object.keys(months),
        datasets: [
          {
            type: 'line',
            label: 'Budget',
            backgroundColor: colorCotton,
            borderColor: colorCotton,
            data: anualValor,
            borderDash: [5, 5],
          },
          {
            ...config2,
            type: 'bar',
            label: 'Real',
            backgroundColor: colorSintetico,
            borderColor: colorSintetico,
            data: anualAmountT,
            // fill: true,
          },
        ],
      },
      options: {
        interaction: {
          intersect: false,
          mode: 'index',
        },
        onClick: (event, elements) => {
          if (elements.length > 0) {
            const index = elements[0].index;
            const selectedYear = date.getFullYear()
            const formattedDate = new Date(selectedYear, index);
            setDateSelected(formattedDate)
            setShowModalMensuales(true);
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: `${getLabel(baseLang, "ventasAnuales", config.language)}` + ` - ${date.getFullYear()}`,
            color: colorTitle,
          },
          datalabels: datalabelsLineGerencia,
          aspectRatio: 5 / 3,
          elements: {
            line: {
              fill: false,
              tension: 0.4
            }
          },
          legend: {
            position: 'bottom',
            labels: {
              color: colorTitle,
              font: {
                size: 11,
              },
            },
          },
          tooltip: {
            callbacks: {
              footer: (e) => e[0]?.raw > 0 ? ('Cumplimiento: ' + (e[1]?.raw / e[0]?.raw * 100).toFixed(2) + '%') : '',
            }
          },
        },
        scales: {
          x: {
            ticks: {
              color: getTitle(config),
            }
          },
          y: {
            ticks: {
              color: getTitle(config),
              callback: (val, index) => {
                return (val > 0 ? '$ ' + formatNumber(val).replace('.00', '') : '')
              }
            }
          }
        },
      }
    })
    setLoading(false);
  }

  useEffect(() => {
    if (date) {
      getInfo();
    }
  }, [date, config])

  useEffect(() => {
    if (getDatos) {
      getInfo()
    }
  }, [getDatos])

  return (
    <div id='resumenVentasAnualD'>
      <Loader loading={loading} querySelector={'#resumenVentasAnualD'} />
      <Card
        titulo={
          <div className='d-flex'>
            {/* <h4 className='mt-2'>Ventas</h4> */}
            <h4 className='mt-2'>{getLabel(baseLang, "ventas", config.language)}</h4>

            {kpiGerencia &&
              <Button
                style={{ zIndex: 1000 }}
                className="p-button-text mx-2"
                tooltip={getLabel(baseLang, "ventas", config.language)}
                icon='pi pi-eye'
                onClick={() => { setShowModal(true); }}
              />
            }
          </div>
        }
        contenido={
          <div style={kpiGerencia ? { display: 'flex' } : {}}>
            <div className='col-12' style={{ flex: 1 }}>
              <Chart height={kpiGerencia ? '250px' : '35vh'} width='100%' type='bar' data={chart.data} options={chart.options} plugins={[ChartDataLabels]} />
            </div>
            {/* <div style={{height:'50vh', width: '100%'}}>
            </div> */}
            {!kpiGerencia && <div className='' style={{ ...(kpiGerencia ? { width: '600px' } : {}), ...(altura ? { height: '369px' } : { height: setHeightAgGrid(table) + 30 }) }}>
              <AgGrid table={table} />
            </div>}
          </div>
        } />


      <Dialog
        visible={showModalMensuales}
        onHide={() => { setShowModalMensuales(false) }}
        header={<h4>{`${getLabel(baseLang, "pMensual", config.language)} (${monthName} / ${dateSelected.getFullYear()}) (Kg)`}</h4>}
        maximized={false}
        closeOnEscape={false}
        style={{ width: '95%', height: '100%' }}
        resizable={false}
      >
        <ResumenVentasTotales kpiGerencia={true} date={dateSelected} setShowModalMensuales={setShowModalMensuales} ventas={true} />
      </Dialog>
    </div>
  );
};

export default ResumenVentasAnual;
